import React from 'react';
import { Landmark } from 'lucide-react';
import { CM_METHODOLOGY } from '../../data/ipoReviewsData';

const BAND_TONES = {
  must: { pill: 'bg-emerald-600 text-white', footer: 'text-emerald-700' },
  may: { pill: 'bg-amber-500 text-white', footer: 'text-amber-700' },
  high: { pill: 'bg-slate-700 text-white', footer: 'text-slate-600' },
  avoid: { pill: 'bg-rose-600 text-white', footer: 'text-rose-600' },
};

export const SmeRatingOverview = () => (
  <section aria-labelledby="sme-rating-desk-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <h2 id="sme-rating-desk-heading" className="flex items-center gap-2 text-sm sm:text-base font-extrabold text-slate-900">
      <Landmark className="w-4 h-4 text-[#008080]" aria-hidden="true" />
      Institutional Rating Desk &amp; Consensus Overview
    </h2>
    <p className="mt-2 text-xs sm:text-[13px] text-slate-600 leading-relaxed">
      SME IPO reviews from brokerage houses and independent analysts are one of the most widely used inputs before
      applying. Each row below collects the research calls published for an SME issue on BSE SME or NSE Emerge, with a
      link to the original note wherever the broker has made it public.
    </p>
    <p className="mt-2 text-xs sm:text-[13px] text-slate-500 leading-relaxed italic">
      Consensus verdict: the call most brokers made. When every broker says Subscribe it shows as{' '}
      <strong className="not-italic text-slate-700">Must Subscribe</strong>; a split view shows the majority call, and
      issues without any published note stay <strong className="not-italic text-slate-700">Awaiting Reviews</strong>.
    </p>

    <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50/70 p-3 sm:p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-[11px] font-extrabold uppercase tracking-wider text-slate-700">CM IPO Rating Key &amp; Investment Criteria</p>
        <p className="text-[11px] text-slate-400">Quantitative 100-point scoring</p>
      </div>
      <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {CM_METHODOLOGY.map((item) => (
          <li key={item.band} className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-extrabold text-slate-800">{item.range.replace('Score ', '')}</span>
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-extrabold ${BAND_TONES[item.band].pill}`}>{item.verdict}</span>
            </div>
            <p className="mt-1 text-[11px] text-slate-500 leading-snug">{item.profile}</p>
            <p className={`mt-1 text-[10px] font-semibold ${BAND_TONES[item.band].footer}`}>{item.footer}</p>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[10px] text-slate-400">CM scores show in the table once Capital Market publishes a rating for the issue.</p>
    </div>
  </section>
);

export default SmeRatingOverview;
